import { useState } from 'react'
import { Icon } from 'react-materialize'
import { device } from '../../Styles/mediaQueries'
import { getEnv } from '../../Utilities/utilities'
import { useMedia } from './useMedia'
import Nav from './Nav'
import { Container, NavToggle, Logo, LogoLink, FloatingBadge } from './Elements'

interface Props {
  username?: string
  permissions?: string[]
}

const SiteNav = ({ username = 'User', permissions = [] }: Props) => {
  const [showNav, setShowNav] = useState(false)

  const navLinkClick = () => {
    setShowNav(false)
  }

  const isMobile = !useMedia(device.mobileL)
  const isBeta = ['staging', 'local'].includes(getEnv())

  return (
    <Container>
      <LogoLink to="/">
        <Logo src="/TaxBitCircleLogo.svg" alt="TaxBit logo" />
        {isBeta && <FloatingBadge label="Beta" />}
      </LogoLink>

      {isMobile && (
        <NavToggle type="button" onClick={() => setShowNav((state) => !state)}>
          {showNav ? <Icon>close</Icon> : <Icon>menu</Icon>}
        </NavToggle>
      )}

      {((isMobile && showNav) || !isMobile) && (
        <Nav
          isMobile={isMobile}
          username={username}
          permissions={permissions}
          onNavLinkClick={navLinkClick}
        />
      )}
    </Container>
  )
}

export default SiteNav
